<template>
    <div>
        <login/>
    </div>
</template>

<script>
import login from '@/components/Login/login.vue';
export default {
  components: { login },
    name: 'BYLogin',

    data() {
        return {
            
        };
    },

    mounted() {
        
    },

    methods: {
        
    },
};
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  font-family: "poppins", sans-serif;
}
</style>